import React from 'react';
import s from './onBoardingNext.scss';
import cx from 'classnames';

var OnBoardingNext = function OnBoardingNext(props) {
  var _cx;

  var onNext = props.onNext,
      nextText = props.nextText,
      _props$bng = props.bng,
      bng = _props$bng === void 0 ? false : _props$bng;
  return /*#__PURE__*/React.createElement("button", {
    className: cx(s.button, s.madeForFont, (_cx = {}, _cx[s.focus] = bng, _cx)),
    onClick: onNext,
    "data-aid": "next-btn"
  }, nextText);
};

export default OnBoardingNext;